export enum LocalStorage_Keys {
    InvoiceResponse = "invoiceApi_response",
    CurrentProductInfo = "current_productInfo"
}